export enum ProfessionType {
    Primary = 0,
    Secondary = 1,
}
